import { Injectable } from '@angular/core';
import { FormFieldMapper } from './field-mapper-base';
import { IFieldMapperStrategy } from './field-mapper-strategy';
import { Question } from '../../../../models';
import { CalculateBoxField } from '../../../../form-field/calculatebox-field';

@Injectable({
    providedIn: 'root'
})
export class CalculateFieldMapper extends FormFieldMapper<CalculateBoxField> implements IFieldMapperStrategy {

    public order = 0;

    public canMap(question: Question): boolean {
        return question.qQuestionFormat.toLowerCase() === 'calculation' ;
    }

    protected mapSpecificProperties(field: CalculateBoxField, question: Question): void {
        field.type = question.subType && question.subType.toLowerCase();        
        field.minLength = question.minLength;
        field.maxLength = question.maxLength;
        field.questionFormat = question.qQuestionFormat;

        const previousAnswer = question.answerSets.filter(ans => ans.isAnswered).pop();
        const defaultValue = question.answerSets.filter(ans => ans.default).pop();
        field.value = previousAnswer ? previousAnswer.name : defaultValue ? defaultValue.name : '';
        field.readOnly = true; // Calculation fields are read-only by default
        field.globalFunction = question.globalFunction || '';
        field.calculationInput = question.calculationInput || false;
    }

    protected getInstance() {
        return new CalculateBoxField();
    }
}
